import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d9e4ddfa"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "adv-view"
};
const _hoisted_2 = {
  key: 0,
  class: "ten-view"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 1,
  class: "horizontal-view"
};
const _hoisted_5 = {
  key: 2,
  class: "news-view"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, null, -1));

const _hoisted_7 = ["onClick"];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "arrow"
}, null, -1));

import { ref } from 'vue';
import composition from '@/composition';
export default {
  props: {
    model: Object
  },

  setup(__props) {
    const props = __props;
    const {
      clickAd
    } = composition();
    let newsIndex = ref(0);

    if (props.model && props.model.dataBroadcast && props.model.dataBroadcast.length > 1) {
      // 即时快讯
      setInterval(() => {
        if (newsIndex.value < props.model.dataBroadcast.length - 1) {
          newsIndex.value++;
        } else {
          newsIndex.value = 0;
        }
      }, 5000);
    }

    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");

      return __props.model ? (_openBlock(), _createElementBlock("div", _hoisted_1, [__props.model.dataTopLogoTen && __props.model.dataTopLogoTen.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.model.dataTopLogoTen, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "cell",
          key: item.id,
          onClick: $event => _unref(clickAd)(item)
        }, [_createVNode(_component_van_image, {
          class: "img",
          src: item.imgPath,
          fit: "cover",
          Lazyload: ""
        }, null, 8, ["src"]), _createElementVNode("p", null, _toDisplayString(item.title), 1)], 8, _hoisted_3);
      }), 128))])) : _createCommentVNode("", true), __props.model.dataTopHorizontal && __props.model.dataTopHorizontal.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.model.dataTopHorizontal, item => {
        return _openBlock(), _createBlock(_component_van_image, {
          class: "img",
          key: item.id,
          src: item.imgPath,
          fit: "cover",
          onClick: $event => _unref(clickAd)(item),
          Lazyload: ""
        }, null, 8, ["src", "onClick"]);
      }), 128))])) : _createCommentVNode("", true), __props.model.dataBroadcast && __props.model.dataBroadcast.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.model.dataBroadcast, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "text",
          key: item.id,
          onClick: $event => _unref(clickAd)(item)
        }, _toDisplayString(item.title), 9, _hoisted_7)), [[_vShow, index == _unref(newsIndex)]]);
      }), 128)), _hoisted_8])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }

};